<template>
	<CDialog
		:visible="visible"
		:title="title"
		:show-confirm="showConfirm"
		:confirm-options="confirmationOptions"
		custom-class="dialog--medium organization-settings-plan app-styled-form sign-agreement-dialog"
		custom-styles="--text: initial; --background: initial; --primary: initial; --secondary: initial; --important: initial; --derived-text-for-primary: initial; --derived-text-for-important: initial; --derived-primary-text-for-background: initial; --derived-primary-icon-for-background: initial; --icon-success: initial; --icon-warning: initial; --icon-error: initial;"
		@done="$emit('close')"
	>
		<CForm
			:id="formId"
			ref="form"
			iframe
			custom-namespace="c-content"
			:site="site"
			:org="org"
			:styling="formStyling"
			:prefill="prefillData"
			@after-submit="afterSubmit"
			@failed-validation="failedValidation"
			@formReady="status = 'default'"
		/>
		<template #footer>
			<button class="c-modal-button c-modal-button-cancel button--secondary" @click="$emit('close')">
				{{ buttonText }}
			</button>
			<CStatusButton
				v-if="shouldShowAgree"
				:status="status"
				class="c-modal-button button--primary"
				@click="submitForm"
			>
				I Agree
			</CStatusButton>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent, ref } from 'vue';
	import CForm from 'src/components/embeds/CognitoForm.vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CStatusButton from 'src/components/interaction/StatusButton.vue';

	const formStyling = ':root:root:root:root:root .cog-header, :root:root:root:root:root .cog-page__navigation { display: none; }';

	export default defineComponent({
		name: 'CSignAgreementDialog',
		components: {
			CForm,
			CDialog,
			CStatusButton
		},
		props: {
			formId: { type: String, required: true },
			site: { type: String, default: undefined },
			org: { type: String, default: 'Ri6aAJ7sHkKfWelbeqMQkw' },
			visible: { type: Boolean, default: false },
			title: { type: String, default: '' },
			customClass: { type: String, default: '' },
			prefillData: { type: Object, required: true },
			allowConfirm: { type: Boolean, default: false },
			confirmationOptions: { type: Object, default: null }
		},
		emits: ['after-submit'],
		setup() {
			return {
				formStyling,
				formSubmitted: ref(false),
				status: ref('disabled')
			};
		},
		computed: {
			shouldShowAgree() {
				return !this.formSubmitted;
			},
			buttonText() {
				return this.formSubmitted ? 'Close' : 'Cancel';
			},
			showConfirm() {
				return this.status === 'validating' && this.allowConfirm;
			}
		},
		methods: {
			submitForm() {
				this.status = 'validating';

				this.$refs.form.submit();
			},
			afterSubmit(e) {
				// removes the agree button after submission
				this.formSubmitted = true;
				this.status = 'default';

				this.$emit('after-submit', e);
			},
			failedValidation() {
				this.status = 'error';
			}
		}
	});
</script>

<style lang="scss">
/* stylelint-disable selector-max-specificity */

.sign-agreement-dialog {

	.el-dialog__header {
		color: var(--matins);
	}

	.dialog__content-container {
		max-height: calc(100vh - 236px);
		/* stylelint-disable-next-line declaration-block-no-duplicate-properties */
		max-height: calc(100dvh - 236px);
		margin-right: -$space__5;
		margin-left: -$space__5;
		padding: $space__5;

		@include scrollbar;
	}
}
</style>